import { render, staticRenderFns } from "./approval-process.vue?vue&type=template&id=527f8f2c&scoped=true"
import script from "./approval-process.vue?vue&type=script&lang=js"
export * from "./approval-process.vue?vue&type=script&lang=js"
import style0 from "./approval-process.vue?vue&type=style&index=0&id=527f8f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f8f2c",
  null
  
)

export default component.exports